/*---------------State Management-----------------*/
import { makeAutoObservable, runInAction } from "mobx";

/*---------------API Client-----------------------*/
import agent from "../api/agent";

/*---------------Types & Models-------------------*/
import { CustomerListFilter, CustomerList } from "../models/Customer";


const { Customer } = agent;
export default class CustomerStore {
  customers: CustomerList[] = []; // For paginated table
  customer: CustomerList | null = null;
  loadingCustomer: boolean = false;
  customerCount: number = 0;
  allCustomers: CustomerList[] = []; // Cached all customers for dropdown

  constructor() {
    makeAutoObservable(this);
  }

  fetchCustomers = async (filterOpts: CustomerListFilter) => {
    this.setLoadingCustomer(true);
    try {
      runInAction(() => {
        this.customers = [];
      });
      const response = await Customer.list(filterOpts);
      runInAction(() => {
        this.customers = response.data;
        this.customerCount = response?.count ?? 0;
      });
      this.setLoadingCustomer(false);
    } catch (err) {
      this.setLoadingCustomer(false);
    }
  };

  // Fetch all customers for dropdown (independent of table list)
  fetchAllCustomersForDropdown = async () => {
    if (this.allCustomers.length > 0) return; // Already cached
    
    try {
      const response = await Customer.list({ pageNo: 1, pageLength: 1000 });
      runInAction(() => {
        this.allCustomers = response.data;
      });
    } catch (error) {
      console.error("Failed to fetch all customers for dropdown", error);
    }
  };

  setLoadingCustomer(val: boolean) {
    this.loadingCustomer = val;
  }
}
